<template>
<transition name="come">
    <div class="notification" v-if="shown" :class="{ yellow: currentType.class === 'yellow', 
                                                     blue: currentType.class === 'blue', 
                                                     red: currentType.class === 'red', 
                                                     green: currentType.class === 'green'  }">
        <div class="not-state">
            <font-awesome-icon class="icon" fixed-width :icon="['fas', currentType.icon]" />
        </div>
        <div class="not-cont pl-20 pt-20 pb-20">
            <div class="not-title dark-body-text mb-5">{{ currentType.label }}</div>
            <p>{{ text }}</p>
        </div>
    </div>
</transition>
</template>
<script>
import TweenLite from 'gsap/TweenLite';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component()
export default class Notification extends Vue {
    shown = false;

    text = '';

    timeout = '';

    get notification() {
        return this.$store.state.notification;
    } 

    @Watch('notification')
    onNotChange(not) {
        this.shown = false;
        setTimeout(() => {
            this.currentType = this.types[not.type];
            this.text = not.text;
            this.shown = true;
        }, 1)
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.shown = false;
        }, 2000)
    }

    types = {
        'info': {
            label: 'Инфо',
            class: 'blue',
            icon: 'info',
        },
        'alert': {
            label: 'Внимание',
            class: 'yellow',
            icon: 'exclamation',
        },
        'error': {
            label: 'Ошибка',
            class: 'red',
            icon: 'exclamation',
        },
        'action': {
            label: 'Инфо',
            class: 'green',
            icon: 'check',
        },
    }

    currentType = this.types['action'];

}

</script>
<style lang="stylus" scoped>
    @import '../styles/main.core.vars.styl';

    .not-state
        min-height: 80px
        width: 30px
        display: flex
        align-items: center
        justify-content: center

    .not-cont
        min-height: 80px

    .notification
        z-index: 4500
        position: fixed
        bottom: 10px
        left: 0
        right: 0
        margin: auto
        background: #FFF
        width: 399px
        height: auto
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
        border-radius: 4px;
        font-size: 15px
        display: flex
        overflow: hidden
        .icon
            font-size: 15px
            color: #fff
        &.yellow
            background: #F2C94C
        &.red
            .not-state
                background: $red_color
        &.green
            .not-state
                background: $green_color
        &.blue
            .not-state
                background: #2F80ED

    .come-enter-active, .come-leave-active
        transition: 0.3s

    .come-enter
        transform: translateY(50px)
    
    .come-enter, .come-leave-to
        opacity: 0

    .come-enter-to, .come-leave
        opacity: 0.9

    .come-enter-to
        transform: translateY(0)

    @media(max-width: 576px)
        .notification
            bottom: 0
            border-radius: 0
            border: 0 !important
            opacity: 1
</style>
